module.exports = __webpack_public_path__ + "bn.f6d5f4005cca9ebb9883.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/4x3/bn.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/4x3/bn.svg
// module chunks = styles